import React, { useEffect, useState } from "react";
import SectionCard from "./SectionCard";
import { Col, Form, message, Row } from "antd";
import ReusableInput from "./ReusableInput";
import MobileInput_v2 from "../../components/common/ReusableMobileInput";
import SearchAddress_v2 from "./SearchAddress_v2";
import EditPenIcon from "../../../assets/images/editPenn.svg";
import ContextualModal from "../../common/ContextualModal";
import { getCommaSeparatedAddress } from "../../components/orders/helpers";
import AddressInfo from "../../components/common/AddressInfo";

const ConsigneeDetails = ({
    form,
    getFieldDecorator,
    viewType = 'create',
    consigneeDetails = {},
    getDataRef,
    currentOrder,
    currentOrg,
    refreshDetails,
    updateLocationDetails,
    updateDurationDetails,
    updateReceivedDetails,
    updateDeliverByDetails,
    updateAppointmentDetails,
    updateActualDetails,
    updateConsigneeName,
    updateConsigneePhone,
    updateConsigneeAddress,
    locked = false,
    orgSettings = {},
    selectedWarehouse,
}) => {
    // const { getFieldDecorator } = form
    const [formData, setFormData] = useState({
        first_name: "",
        phone: "",
        city: "",
        state: "",
        country: "",
        address_line1: "",
        address_line2: "",
        coordinates: [],
        zipcode: "",
        ...consigneeDetails
    })
    const [openConsigneeDetailsModal, setOpenConsigneeDetailsModal] = useState(false);
    const [titleAddressDetails, setTitleAddressDetails] = useState({
        title: "",
        isAddressForm: false,
        key: "",
    });
    const [modalPosition, setModalPosition] = useState({
        top: 0,
        left: 0,
    });

    const modalPositioner = {
        consigneeAddress: {
            top: 10,
            left: 440,
        },
        contactName: {
            top: 10,
            left: 250,
        },
        contactPhone: {
            top: 10,
            left: 250,
        },
    }

    useEffect(() => {
        if (currentOrder?.consignee_details) {
            setFormData({
                first_name: currentOrder.consignee_details.consignee_first_name || "",
                phone: currentOrder.consignee_details.consignee_phone_number || "",
                city: currentOrder.consignee_details.consignee_address_city || "",
                state: currentOrder.consignee_details.consignee_address_state || "",
                country: currentOrder.consignee_details.consignee_address_country || "",
                address_line1: currentOrder.consignee_details.consignee_address_line_1 || "",
                address_line2: currentOrder.consignee_details.consignee_address_line_2 || "",
                coordinates: currentOrder.consignee_details.coordinates || [],
                zipcode: currentOrder.consignee_details.consignee_address_zipcode || "",
            });
        }
    }, [currentOrder]);

    const formsToRender = {
        ConsigneeAddress: ["Consignee Address"],
        ConsigneeName: ["Consignee Name"],
        ConsigneeContact: ["Consignee Contact"],
    }
//     const [locked, setLocked] = useState(false); 
//     useEffect(() => {
//       if (currentOrder?.customer_order_details?.is_locked !== undefined) {
//           setLocked(currentOrder.customer_order_details.is_locked === "true" ? true : false);
//       }
//   }, [currentOrder]);

    const ComponentKey = () => {
        const toBeRendered = Object.keys(formsToRender).find((key) =>
            formsToRender[key].includes(titleAddressDetails.title)
        );
        return toBeRendered;
    };

    const renderConsigneeDetailsModal = () => {
        return (
            <ContextualModal
                openModal={openConsigneeDetailsModal}
                onClose={() => {
                    setOpenConsigneeDetailsModal(false);
                    setTitleAddressDetails({
                        title: "",
                        isAddressForm: false,
                        key: "",
                    });
                    // setVerifyLosFromScreen(false);
                }}
                labelTitle={titleAddressDetails.title}
                isAddressForm={titleAddressDetails.isAddressForm}
                modalPosition={modalPosition}
                keyToBeUsed={titleAddressDetails.key}
                formsToRender={ComponentKey()}
                currentOrder={currentOrder}
                currentOrg={currentOrg}
                prevFormVlaues={titleAddressDetails.prevFormVlaues}
                refreshDetails={refreshDetails}
                updateLocationDetails={updateLocationDetails}
                updateDurationDetails={updateDurationDetails}
                updateReceivedDetails={updateReceivedDetails}
                updateDeliverByDetails={updateDeliverByDetails}
                updateAppointmentDetails={updateAppointmentDetails}
                updateActualDetails={updateActualDetails}
                updateConsigneeName={updateConsigneeName}
                updateConsigneePhone={updateConsigneePhone}
                updateConsigneeAddress={updateConsigneeAddress}
                setOpenAddressCredsModal={setOpenConsigneeDetailsModal}
                isMilitaryTime={orgSettings?.is_military_time == "true"}
            />
        )
    }

    const setPropsData = (key) => {
        switch (key) {
            case "consigneeAddress":
                return {
                    consignee_address_city: consigneeDetails?.consignee_address_city || "",
                    consignee_address_state: consigneeDetails?.consignee_address_state || "",
                    consignee_address_country: consigneeDetails?.consignee_address_country || "",
                    consignee_address_line_1: consigneeDetails?.consignee_address_line_1 || '',
                    consignee_address_line_2: consigneeDetails?.consignee_address_line_2 || '',
                    consignee_address_zipcode: consigneeDetails?.consignee_address_zipcode || "",
                };
            case "contactName":
                return { consignee_first_name: consigneeDetails.consignee_first_name };
            case "contactPhone":
                return { consignee_phone_number: consigneeDetails.consignee_phone_number };
            default:
                return "params";
        }
    }

    const renderTitleAddressDetails = (key, title, isAddressForm = false) => {
        const prevFormVlaues = { [key]: setPropsData(key) };
        setOpenConsigneeDetailsModal(true);
        setTitleAddressDetails({
            title: title,
            isAddressForm: isAddressForm,
            key,
            prevFormVlaues,
        });
    };

    const positionEditModal = (event, key) => {
        const elementPosition = event.target.getBoundingClientRect();
        setModalPosition({
            top: elementPosition.top + window.scrollY - modalPositioner[key].top,
            left: elementPosition.left + window.scrollX - modalPositioner[key].left,
        });
    };

    const handleOnChange = (key, value) => {
        // If key is 'phone', validate the phone number
        if (key === 'phone') {
            const phoneWithoutCountryCode = value.replace(/[^0-9]/g, '');
            const countryCodeLength = value.startsWith('+') ? 1 : 0;
            const isValid = !phoneWithoutCountryCode || phoneWithoutCountryCode.length - countryCodeLength >= 10;

            if (!isValid) {
                setFormData((prevLocation) => ({
                    ...prevLocation,
                    [key]: value,
                    phoneError: true,
                }));
            } else {
                // If valid, clear the error
                setFormData((prevLocation) => ({
                    ...prevLocation,
                    [key]: value,
                    phoneError: '', // Clear error when valid
                }));
            }
        } else {
            setFormData((prevLocation) => ({
                ...prevLocation,
                [key]: value,
            }));
        }
    };

    useEffect(() => {
        if (getDataRef) {
            getDataRef.current = () => (formData)
        }
    }, [getDataRef, formData])

    const onAddressSelect = (selectedAddress) => {
        setFormData({
            ...formData,
            city: selectedAddress?.l_address?.city || "",
            state: selectedAddress?.l_address?.state || "",
            country: selectedAddress?.l_address?.country || "",
            address_line1: selectedAddress?.l_address?.address_line1 || '',
            address_line2: selectedAddress?.l_address?.address_line2 || '',
            coordinates: selectedAddress?.l_address?.coordinates || [],
            zipcode: selectedAddress?.l_address?.zipcode || "",
        })
    };

    const displayAddress = () => {
        return (
            <AddressInfo
                address={{
                    address_line1: consigneeDetails?.consignee_address_line_1,
                    address_line2: consigneeDetails?.consignee_address_line_2,
                    city: consigneeDetails?.consignee_address_city,
                    state: consigneeDetails?.consignee_address_state,
                    country: consigneeDetails?.consignee_address_country,
                    zipcode: consigneeDetails?.consignee_address_zipcode,
                }}
            />
        )
    }

    return (
        <SectionCard
            title='Consignee Details'
        >
            {["create", "full_edit"].includes(viewType) ?
                <>
                    <Row gutter={16} className="create-consignee-details-tab">
                        <Col span={12} className="custom-form-item" data-testid="consignee-address">
                            <Form.Item label="Address">
                                {getFieldDecorator("address", {
                                    rules: [
                                        {
                                            required: false,
                                            message: "Address is required",
                                        },
                                    ],
                                })(
                                    <SearchAddress_v2
                                        onSelect={onAddressSelect}
                                        doesAddressExist={true}
                                        address={getCommaSeparatedAddress(formData)}
                                        selectedWarehouseId={selectedWarehouse}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={6} className="custom-form-item">
                            <Form.Item label="Contact Name">
                                <ReusableInput
                                    data-testid="contact-name-input"
                                    label={"Contact Name"}
                                    placeholder=""
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={(e) =>
                                        handleOnChange("first_name", e.target.value)
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6} className="custom-form-item" data-testid="contact-phone-input">
                            <Form.Item label="Contact Phone" 
                                // help={formData.phoneError}
                                // validateStatus={formData.phoneError ? 'error' : ''}
                            >
                                <MobileInput_v2
                                    value={formData.phone}
                                    handleInputChange={(val, data) =>
                                        handleOnChange("phone", val)
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
                :
                <>
                    <Row gutter={16} className="consignee-details-view">
                        <Col span={12} className="consignee-details-section">
                            <div className="consignee-details-heading">Address</div>
                            <div className="consignee-details-desc">{consigneeDetails?.consignee_address_line_1 ? displayAddress() : "Not Available"}</div>
                           {!locked &&(
                            <img className="edit-icon" src={EditPenIcon}
                                onClick={(event) => {
                                    renderTitleAddressDetails("consigneeAddress", "Consignee Address");
                                    positionEditModal(event, "consigneeAddress");
                                }}
                            />
                           )}
                        </Col>
                        <Col span={6} className="consignee-details-section">
                            <div className="consignee-details-heading">Contact Name</div>
                            <div className="consignee-details-desc">{consigneeDetails?.consignee_first_name || 'Not Available'}</div>
                            {!locked &&(
                            <img className="edit-icon" src={EditPenIcon}
                                onClick={(event) => {
                                    renderTitleAddressDetails("contactName", "Consignee Name");
                                    positionEditModal(event, "contactName");
                                }}
                            />
                            )}
                        </Col>
                        <Col span={6} className="consignee-details-section">
                            <div className="consignee-details-heading">Contact Phone</div>
                            <div className="consignee-details-desc">{consigneeDetails?.consignee_phone_number || 'Not Available'}</div>
                            {!locked &&(
                            <img className="edit-icon" src={EditPenIcon}
                                onClick={(event) => {
                                    renderTitleAddressDetails("contactPhone", "Consignee Contact");
                                    positionEditModal(event, "contactPhone");
                                }}
                            />
                            )}
                        </Col>
                    </Row>
                    {openConsigneeDetailsModal && renderConsigneeDetailsModal()}
                </>
            }
        </SectionCard>
    )
}

export default ConsigneeDetails